import { render, staticRenderFns } from "./RecipientImageComponent.vue?vue&type=template&id=323557d5&"
import script from "./RecipientImageComponent.vue?vue&type=script&lang=ts&"
export * from "./RecipientImageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports